import { ErrorPageHero } from '@modules/error/component/error-page-hero/ErrorPageHero';

const NotFound = () => {
    return (
        <ErrorPageHero
            heading="404"
            headingVariant="code"
            description="Sorry, this page has been moved or does not exist."
            cta={{ label: 'Back to Homepage', to: '/' }}
        />
    );
};

export default NotFound;
